import { useFormikContext } from 'formik';
import { ChangeEvent } from 'react';
import { Col, Row } from 'react-bootstrap';
import { KEY_LOCALSTORAGE } from '../../../../../auth/core/_consts';
import AutocompleteV2 from '../../../../../component/AutocompleteObjectV2';
import LabelRequired from '../../../../../component/LabelRequired';
import TextField from '../../../../../component/TextField';
import {
	APP_CONFIGURATION_KEYS,
	DEFAULT_PAGE_INDEX,
	DEFAULT_PAGE_SIZE,
	LEVEL,
	LOAI_PHONG,
} from '../../../../../utils/Constant';
import { convertToStringWithDelimiter } from '../../../../../utils/FormatUtils';
import { localStorageItem } from '../../../../../utils/LocalStorage';
import {
	getDepartmentsByOrganization,
	getJsonGenerateForms,
	getListKhoaPhong,
	getObsComplexCategory,
	getUsers,
} from '../../../../../utils/ServicesUtils';

const API_PATH_INPATIENT =
	localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.INPATIENT_URL] ||
	process.env.REACT_APP_INS_API_URL;

const ThongTinChung = () => {
	const { values, touched, errors, setFieldValue, setValues } = useFormikContext<any>();

	const onMedicalRecordSelect = async (selectedOption: any) => {
		setFieldValue('medicalRecord', selectedOption);
		const mauPhieuKham = selectedOption?.mauPhieuKhamBenh;

		if (!selectedOption || !mauPhieuKham) {
			setFieldValue('template', null);
			setFieldValue('jsonTemplate', null);
			return;
		}

		try {
			const { data } = await getJsonGenerateForms(mauPhieuKham);
			setFieldValue('template', {
				code: mauPhieuKham,
			});
			setFieldValue('jsonTemplate', data.data[mauPhieuKham]);
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<>
			<Row className="spaces pt-10">
				<Col>
					<LabelRequired label="Khoa điều trị" isRequired />
					<AutocompleteV2
						options={[]}
						searchFunction={getDepartmentsByOrganization}
						searchObject={{
							level: LEVEL.KHOA,
							type: LOAI_PHONG.DIEU_TRI,
						}}
						name="treatmentDept"
						onChange={(option) => {
							setFieldValue('treatmentDept', option);
							
							if (!option) {
								setFieldValue('treatmentRoom', null);
							}
						}}
						getOptionLabel={(option) => `${option.code} - ${option.name}`}
						value={values?.treatmentDept}
						touched={touched?.treatmentDept}
						errors={errors?.treatmentDept}
						menuPlacement="bottom"
						urlData='data.content'
						isSrcoll
						isSearchable
						labelSearch="keyword"
					/>
				</Col>
				<Col>
					<LabelRequired label="Phòng điều trị" isRequired/>
					<AutocompleteV2
						options={[]}
						searchFunction={getDepartmentsByOrganization}
						searchObject={{
							level: LEVEL.PHONG,
							type: LOAI_PHONG.DIEU_TRI,
							parentCode: values?.treatmentDept?.code,
						}}
						dependencies={[values?.treatmentDept?.code]}
						name="treatmentRoom"
						onChange={(option) => setFieldValue('treatmentRoom', option)}
						getOptionLabel={(option) => `${option.code} - ${option.name}`}
						value={values?.treatmentRoom}
						touched={touched?.treatmentRoom}
						errors={errors?.treatmentRoom}
						menuPlacement="bottom"
						disabled={!values?.treatmentDept}
						urlData='data.content'
						isSrcoll
						isSearchable
						labelSearch="keyword"
					/>
				</Col>
			</Row>
			<Row>
				<Col>
					<LabelRequired className="min-w-150px" label="Bác sĩ điều trị" />
					<AutocompleteV2
						options={[]}
						value={values?.doctor}
						name="doctor"
						searchFunction={getUsers}
						searchObject={{
							pageIndex: DEFAULT_PAGE_INDEX,
							pageSize: DEFAULT_PAGE_SIZE,
						}}
						urlData="data.data.content"
						getOptionLabel={(option: any) =>
							convertToStringWithDelimiter([option?.fullName, option?.username], '-')
						}
						getOptionValue={(option: any) => option?.id}
						onChange={(selectedOption) => {
							setFieldValue('doctor', selectedOption);
						}}
						isSearchable
						isSrcoll
						labelSearch="keyword"
					/>
				</Col>
				<Col>
					<LabelRequired className="min-w-150px" label="Loại bệnh án" isRequired />
					<AutocompleteV2
						options={[]}
						searchFunction={getObsComplexCategory}
						searchObject={{
							path: API_PATH_INPATIENT,
							code: 'dmloaibenhan',
							pageIndex: 1,
							pageSize: 9999,
							keyword: true,
						}}
						urlData="data.content"
						value={values?.medicalRecord}
						name="medicalRecord"
						onChange={(selectedOption) => {
							onMedicalRecordSelect(selectedOption);
						}}
						errors={errors?.medicalRecord}
						touched={touched?.medicalRecord}
					/>
				</Col>
			</Row>
			<Row className="spaces pt-10">
				<Col xs={12}>
					<LabelRequired label="Lý do điều trị" />
					<TextField
						className="w-100 d-flex resize-none"
						name="treatmentReason"
						labelClassName="ms-0 min-w-145px"
						as="textarea"
						rows="5"
						value={values?.treatmentReason || ''}
						onChange={(e: ChangeEvent<HTMLInputElement>) => {
							setFieldValue('treatmentReason', e.target.value);
						}}
					/>
				</Col>
			</Row>
		</>
	);
};

export default ThongTinChung;
